/** Reserved option ids synthesized when builder enables Other / None of the Above. */
export const SURVEY_OPTION_OTHER_ID = '__other__'
export const SURVEY_OPTION_NONE_ID = '__none_of_above__'

export const SURVEY_OPTION_OTHER_LABEL = 'Other'
export const SURVEY_OPTION_NONE_LABEL = 'None of the above'

export function isSurveyOtherOptionId(id: string): boolean {
  return id === SURVEY_OPTION_OTHER_ID
}

export function isSurveyNoneOptionId(id: string): boolean {
  return id === SURVEY_OPTION_NONE_ID
}
